import script from "./UserTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UserTable.vue?vue&type=script&setup=true&lang=js"

import "./UserTable.vue?vue&type=style&index=0&id=87efea30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87efea30"]])

export default __exports__